<template>
  <button :class="buttonClasses" :disabled="disabled" @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "VoteResult",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    decision: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    borderColor: {
      type: String,
      required: false
    }
  },
  computed: {
    buttonClasses() {
      const voteClasses = {
        Yes: "vote-yes",
        No: "vote-no"
      };

      return [
        "text-chplus-regular py-2 px-3 text-center rounded-lg font-bold hover:text-white vote-button",
        voteClasses[this.decision] || "vote-other",
        {
          active: this.active,
          "cursor-default": this.disabled
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-button {
  background: transparent;
  min-width: 5rem;
  border-width: 3px;
}

.vote-button:hover,
.vote-button.active {
  color: white !important;
}

.vote-button.vote-yes {
  border-color: #7fb59f;
  color: #7fb59f;

  &.active,
  &:hover {
    background-color: #7fb59f;
  }
}

.vote-button.vote-no {
  border-color: #7a7a7a;
  color: #7a7a7a;

  &.active,
  &:hover {
    background-color: #7a7a7a;
  }
}

.vote-button.vote-other {
  border-color: var(--interaction-dark);
  color: var(--interaction-dark);

  &.active,
  &:hover {
    background-color: var(--interaction-dark);
  }
}
</style>
